"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const buildValidator_1 = __importDefault(require("./buildValidator"));
const throwValidationError_1 = __importDefault(require("./throwValidationError"));
const valueIsArray_1 = __importDefault(require("./valueIsArray"));
const buildValueIsArrayOf = (itemValidator) => {
    const typeName = `Array<${itemValidator.typeName}>`;
    const validationFunction = (value, options) => {
        if (!(0, valueIsArray_1.default)(value)) {
            if (options) {
                (0, throwValidationError_1.default)(options.path, typeName, value);
            }
            return false;
        }
        const itemNotOfTypeIndex = value
            .findIndex((item, itemIndex) => !itemValidator(item, options ? Object.assign(Object.assign({}, options), { path: [...options.path, itemIndex] }) : undefined));
        if (itemNotOfTypeIndex !== -1) {
            return false;
        }
        return true;
    };
    return (0, buildValidator_1.default)(typeName, validationFunction);
};
exports.default = buildValueIsArrayOf;
